import ExcelJS from 'exceljs';
import dayjs from 'dayjs';
import {saveAsAM, AMStats} from '../../../ApiCenter/API_GET'
import {coordinateX, setCell} from '../../../ApiCenter/AM_ExcelSupport'
import path from 'path-browserify';

export const fileManagerExport = async (props) => {

    let line = 1;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Report");

    const headerTitles = [
        {title: "Source/Target", w: 10},
        {title: 'Filename', w: 40},
        {title: 'File Path', w: 40},
        {title: 'Full FilePath', w: 40},
        {title: 'Uploader', w: 20},
        {title: 'Date', w: 18, align: 'center'},
        {title: 'File Type', w: 20, align: 'center'},
        {title: 'File Size', w: 12, align: 'center'},
        {title: 'Transcription', w: 50}
    ]

    headerTitles.forEach((header, index) => {
        setCell(worksheet, `${coordinateX(index)}${line}`, header.title, { font: { bold: true, size: 12 }, fgColor: '00487E', color: 'FFFFFF', align: header.align ?? 'left'});
    })

    worksheet.autoFilter = 'A1:H1';

    worksheet.columns.forEach((column, index) => {
        column.width = headerTitles[index].w;
    });

    props.forEach(el => {
        line++;
        let column = 0;
        const parseFilename = path.parse(el.name)

        setCell(worksheet, `${coordinateX(column++)}${line}`, el.filterPath.split('/')[0] ?? null);
        setCell(worksheet, `${coordinateX(column++)}${line}`, parseFilename.base);
        setCell(worksheet, `${coordinateX(column++)}${line}`, el.filterPath);
        setCell(worksheet, `${coordinateX(column++)}${line}`, el.name);
        setCell(worksheet, `${coordinateX(column++)}${line}`, el.uploader);
        setCell(worksheet, `${coordinateX(column++)}${line}`, dayjs(el.dateCreated).toDate(), {dataType: 'dateTime', align: 'center'});
        setCell(worksheet, `${coordinateX(column++)}${line}`, el.type, {align: 'center'});
        setCell(worksheet, `${coordinateX(column++)}${line}`, el.size, {align: 'center'});
        setCell(worksheet, `${coordinateX(column++)}${line}`, el.transcription_text, {wrapText: true});


    })

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer]);

    const opts = {
            suggestedName: `${dayjs().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
            types: [{
                description: 'Excel Files',
                accept: { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] },
            }],
        };

    await saveAsAM(blob, 'Test.xlsx', opts);
      
}
